import { render } from "./VodacomDepositWebsite.vue?vue&type=template&id=77c76518&scoped=true"
import script from "./VodacomDepositWebsite.vue?vue&type=script&lang=js"
export * from "./VodacomDepositWebsite.vue?vue&type=script&lang=js"

import "./VodacomDepositWebsite.vue?vue&type=style&index=0&id=77c76518&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77c76518"]])

export default __exports__